import { Component, OnInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { SessionService } from './core/auth/session.service';
import { ApiService } from './core/http/api.service';
import { filter, map, mergeMap } from "rxjs/operators";
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CoorporateConfigService } from './shared/services/coorporate.config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  menuMode = 'sidebar';
  layout = 'blue';
  theme = 'blue';
  ripple!: boolean;
  colorScheme = 'dark';
  subscription: Subscription;
  preTitle: string = '';

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public translate: TranslateService,
    private corpConfig: CoorporateConfigService,
    private session: SessionService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === "primary"),
      mergeMap(route => route.data)
    ).subscribe(event => {
      this.titleService.setTitle(
        `${this.corpConfig.projectName ? this.session.getItem('projectName') + " | " : " "} ${event["title"] ? event["title"] : ""
        }`
      )
    }
    );
    translate.addLangs(['es-MX']);
    translate.setDefaultLang('es-MX');

    this.subscription = this.translate.stream('primeng').subscribe(data => {
      this.primengConfig.setTranslation(data);
    });
  }

  async ngOnInit(): Promise<void> {
    this.primengConfig.ripple = true;
    this.ripple = true;
  }
}
